import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import ProcessingContainer from '../Processing/ProcessingContainer';

interface AgentCreationProcessingScreenProps {
  title: string;
  isKnowledgeCreated: boolean;
  isAgentCreated: boolean;
  agentCreatedLabel: string;
  creatingAgentLabel: string;
  isFilesUploaded: boolean;
  // False when the user opted out of a knowledge base: the knowledge-base
  // and file-upload steps don't happen, so only the agent step is listed.
  withKnowledgeBase?: boolean;
}

// The three-step (knowledge base / agent / files) progress list shared by
// AgentForm's and ChatAgentForm's post-submit "creation in progress"
// screens. The agent-specific title and middle-step labels are passed in
// pre-translated, since "Call Agent" vs "Chat Agent" are separate
// translation keys, not a single interpolated template.
const AgentCreationProcessingScreen: React.FC<
  AgentCreationProcessingScreenProps
> = ({
  title,
  isKnowledgeCreated,
  isAgentCreated,
  agentCreatedLabel,
  creatingAgentLabel,
  isFilesUploaded,
  withKnowledgeBase = true,
}) => {
  const { t } = useTranslation();

  const agentItem = {
    text: isAgentCreated ? agentCreatedLabel : creatingAgentLabel,
    isCompleted: isAgentCreated,
  };

  return (
    <ProcessingContainer
      title={title}
      items={
        withKnowledgeBase
          ? [
              {
                text: isKnowledgeCreated
                  ? t('Knowledge Base Created')
                  : t('Creating Knowledge Base...'),
                isCompleted: isKnowledgeCreated,
              },
              agentItem,
              {
                text: isFilesUploaded
                  ? t('Knowledge File(s) Uploaded')
                  : t('Uploading Knowledge File(s)...'),
                isCompleted: isFilesUploaded,
              },
            ]
          : [agentItem]
      }
    />
  );
};

export default AgentCreationProcessingScreen;
